import * as XLSX from "xlsx";
import { useEffect, useState } from "react";
import { getAllShippingWithCustomOrders, getFreeZoneShippingWithCustomOrders, getShippingValueWithCustomOrders, getFBAShipping, getEasyshipShipping } from "./FuncWithCSV";
import { readCSVFile, loadPredefinedCSV } from "./csvUtils";
import { calculateShipping as DFcalculateShipping } from "./df";
import { calculateShipping as AlliedcalculateShipping } from "./allied";
import { calculateShipping as PostcalculateShipping } from "./aupost";
import { calculateShipping as CPcalculateShipping } from "./cp";
import { calculateShipping as FastwaycalculateShipping } from "./fastway";
import { calculateShipping as HuntercalculateShipping } from "./hunter";
import { calculateShipping as FBAcalculateShipping } from "./fba";
import { calculateShippingCost as EasyshipcalculateShipping } from "./easyship";
import { calculateShipping as AramexcalculateShipping } from "./aramex";
import { calculateShipping as DFEcalculateShipping } from "./dfe";
import { calculateShipping as SYDFEcalculateShipping } from "./sydfe";
import { calculateShipping as IMilecalculateShipping } from "./imile";
import { calculateShipping as TNTcalculateShipping } from "./tnt";
import levy from "./data/levy.json";

// Predefined sheets configuration
const predefinedSheets = {
  "now-sheet": {
    name: "Now Sheet",
    filename: "202606"
  },
  "timu-sheet": {
    name: "Temu Sheet",
    filename: "timu-sheet"
  }
};

function CSVShippingPage({ onOrdersDataChange }) {
  const [result, setResult] = useState(null);
  const [testDeliveryResult, setTestDeliveryResult] = useState(null);
  const [ordersCountTable, setOrdersCountTable] = useState({});
  const [weight, setWeight] = useState(0);
  const [inputWeight, setInputWeight] = useState(0);
  const [length, setLength] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [allShipping, setAllShipping] = useState(0);
  const [freeZoneShipping, setFreeZoneShipping] = useState(0);
  const [fbaShipping, setFbaShipping] = useState(0);
  const [easyshipShipping, setEasyshipShipping] = useState(0);
  const [isLarge, setIsLarge] = useState(true);
  // FBA always uses price >= $13 rate. To change: modify the value below
  const FBA_PRODUCT_PRICE = 13;
  const [testPostcode, setTestpostcode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [csvUploaded, setCsvUploaded] = useState(false);
  const [fileName, setFileName] = useState("");
  const [selectedSheet, setSelectedSheet] = useState("now-sheet");
  const [error, setError] = useState("");
  const [dataSource, setDataSource] = useState(""); // "upload" or "predefined"

  // Load Now sheet by default on mount
  useEffect(() => {
    const loadDefaultSheet = async () => {
      try {
        const ordersCounts = await loadPredefinedCSV(predefinedSheets["now-sheet"].filename);
        setOrdersCountTable(ordersCounts);
        setCsvUploaded(true);
        setFileName(predefinedSheets["now-sheet"].name);
        setDataSource("predefined");
        if (onOrdersDataChange) {
          onOrdersDataChange(ordersCounts);
        }
      } catch (error) {
        setError(`Error loading default sheet: ${error.message}`);
      }
    };
    loadDefaultSheet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // CSV file upload handler
  const handleCSVUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setError("");
    try {
      const ordersCounts = await readCSVFile(file);
      setOrdersCountTable(ordersCounts);
      setCsvUploaded(true);
      setFileName(file.name);
      setDataSource("upload");
      setSelectedSheet("");
      if (onOrdersDataChange) {
        onOrdersDataChange(ordersCounts);
      }
    } catch (error) {
      setError(`Error loading CSV: ${error.message}`);
      setCsvUploaded(false);
      setFileName("");
      setOrdersCountTable({});
      if (onOrdersDataChange) {
        onOrdersDataChange({});
      }
    }
  };

  // Predefined sheet selector handler
  const handleSheetSelect = async (event) => {
    const sheetKey = event.target.value;
    setSelectedSheet(sheetKey);
    setError("");

    if (sheetKey && predefinedSheets[sheetKey]) {
      try {
        const ordersCounts = await loadPredefinedCSV(predefinedSheets[sheetKey].filename);
        setOrdersCountTable(ordersCounts);
        setCsvUploaded(true);
        setFileName(predefinedSheets[sheetKey].name);
        setDataSource("predefined");
        if (onOrdersDataChange) {
          onOrdersDataChange(ordersCounts);
        }
      } catch (error) {
        setError(`Error loading predefined sheet: ${error.message}`);
        setCsvUploaded(false);
        setFileName("");
        setOrdersCountTable({});
        setDataSource("");
        if (onOrdersDataChange) {
          onOrdersDataChange({});
        }
      }
    } else {
      setCsvUploaded(false);
      setFileName("");
      setOrdersCountTable({});
      setDataSource("");
      if (onOrdersDataChange) {
        onOrdersDataChange({});
      }
    }
  };

  // Clear data
  const clearData = () => {
    setOrdersCountTable({});
    setCsvUploaded(false);
    setFileName("");
    setSelectedSheet("");
    setDataSource("");
    setError("");
    setResult(null);
    if (onOrdersDataChange) {
      onOrdersDataChange({});
    }
  };

  // Paste from excel
  const [inputValue, setInputValue] = useState("");

  const handlePaste = (event) => {
    event.preventDefault();

    const pastedData = event.clipboardData.getData("text");

    // Convert Excel cell data into comma-separated values
    const formattedData = pastedData
      .trim() // Remove any surrounding whitespace
      .split("\n") // Split rows by new lines
      .map((row) => row.split("\t").join(", ")) // Split columns by tabs and join as comma-separated values
      .join(", ");

    setInputValue(formattedData);

    // Convert Excel cell data into an array by splitting rows and columns
    const values = pastedData
      .trim()
      .split("\n")[0] // Get the first row
      .split("\t"); // Split columns by tabs

    setLength(parseFloat(values[0]));
    setWidth(parseFloat(values[1]));
    setHeight(parseFloat(values[2]));
    setInputWeight(parseFloat(values[3]));
  };

  const handleChange = (event) => {
    const input = event.target.value;

    setInputValue(input);
    // Convert comma-separated input into an array
    const values = input.split(",").map((val) => val.trim());

    setLength(parseFloat(values[0]));
    setWidth(parseFloat(values[1]));
    setHeight(parseFloat(values[2]));
    setInputWeight(parseFloat(values[3]));
  };

  // Check free zone type
  useEffect(() => {
    const calcWeight = (length * width * height) / 4000;
    const maxDim = Math.max(length, width, height);

    if (maxDim <= 100 && inputWeight <= 5) {
      setIsLarge(false); // 小件全区免邮
    } else if (maxDim <= 119 && inputWeight <= 30) {
      setIsLarge(false); // 大件免邮区
    } else {
      setIsLarge(true); // 无免邮区
    }
    setWeight(Math.max(calcWeight, inputWeight));
  }, [length, width, height, inputWeight, inputValue]);

  // Set calculated result matrix
  const calculateShipping = () => {
    setIsLoading(true);
    let shippingValue = [];

    if (weight > 0 && ordersCountTable && Object.keys(ordersCountTable).length > 0) {
      shippingValue = getShippingValueWithCustomOrders(length, width, height, inputWeight, ordersCountTable);

      setAllShipping(getAllShippingWithCustomOrders(length, width, height, inputWeight, ordersCountTable));
      setFreeZoneShipping(getFreeZoneShippingWithCustomOrders(length, width, height, inputWeight, ordersCountTable));
      // FBA calculation: always uses price >= $13 rate (see FBA_PRODUCT_PRICE constant)
      setFbaShipping(getFBAShipping(length, width, height, inputWeight, FBA_PRODUCT_PRICE));
      // Easyship calculation
      setEasyshipShipping(getEasyshipShipping(length, width, height, inputWeight, ordersCountTable));
    } else {
      alert("Please upload CSV file and enter weight/dimensions");
    }

    setResult(shippingValue);
  };

  useEffect(() => {
    if (result && result.length > 0) {
      setIsLoading(false);
      console.log("all data result");
      console.log(result);
    }
  }, [result]);

  const exportToExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to a worksheet
    const ws = XLSX.utils.json_to_sheet(result);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate a downloadable Excel file
    const fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, "");
    XLSX.writeFile(wb, `${fileNameWithoutExt || 'csv'}-shipping-data.xlsx`);
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">CSV Shipping Calculator</h1>

      {/* Instructions */}
      <div className="alert alert-info mb-4">
        <h5>Instructions:</h5>
        <ul className="mb-0">
          <li>Choose a predefined sheet from the dropdown, OR</li>
          <li>Upload your own CSV file with exactly 2 columns: <strong>"postcode"</strong> and <strong>"quantity"</strong></li>
          <li>CSV format example:
            <pre className="mt-2 mb-0">postcode,quantity{'\n'}2000,25{'\n'}3000,45</pre>
          </li>
        </ul>
      </div>

      {/* Error Display */}
      {error && (
        <div className="alert alert-danger mb-4">
          <strong>Error:</strong> {error}
        </div>
      )}

      {/* Predefined Sheets Dropdown - Hidden */}
      {/* <div className="mb-4">
        <label className="form-label">Select a predefined sheet:</label>
        <select
          className="form-control mb-2"
          value={selectedSheet}
          onChange={handleSheetSelect}
        >
          <option value="">-- Select a predefined sheet --</option>
          {Object.entries(predefinedSheets).map(([key, sheet]) => (
            <option key={key} value={key}>{sheet.name}</option>
          ))}
        </select>
      </div>

      <div className="text-center mb-3">
        <strong>OR</strong>
      </div> */}

      {/* CSV Upload */}
      <div className="mb-4">
        <label className="form-label">Upload your own CSV file:</label>
        <input
          type="file"
          accept=".csv"
          onChange={handleCSVUpload}
          className="form-control mb-2"
        />
      </div>

      {/* Success Message */}
      {csvUploaded && (
        <div className="alert alert-success mb-4">
          <strong>{fileName}</strong> loaded successfully!
          <br />
          {Object.keys(ordersCountTable).length} postcodes found.
          <br />
          Data source: {dataSource === "predefined" ? "Predefined sheet" : "Uploaded CSV"}
          <button
            className="btn btn-sm btn-outline-secondary ms-2"
            onClick={clearData}
          >
            Clear Data
          </button>
        </div>
      )}

      <div className="mb-3">
        <label>长，宽，高，重量: </label>
        <input
          type="text"
          className="form-control"
          placeholder="Length, Width, Height, Weight"
          value={inputValue}
          onChange={handleChange}
          onPaste={handlePaste}
        />
      </div>
      <div className="mb-3">体积重量：{weight}</div>
      <div className="mb-3">
        <label className="form-label">测试用 postcode</label>
        <input
          type="number"
          className="form-control"
          id="testPostcode"
          value={testPostcode}
          onChange={(e) => setTestpostcode(e.target.value)}
        />
      </div>

      {weight > 0 && testPostcode && testPostcode.trim() !== "" && (
        <div>
          <h2>测试：</h2>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = AlliedcalculateShipping(
                  testPostcode,
                  weight,
                  length,
                  width,
                  height
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试Allied
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const feeResult = PostcalculateShipping(
                  testPostcode,
                  inputWeight,
                  length,
                  width,
                  height,
                  levy.aupost
                );
                const fee = feeResult.error ? feeResult : { ...feeResult, cost: feeResult.cost * 1.1 };
                setTestDeliveryResult(fee);
              }}
            >
              测试AUPost
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = AramexcalculateShipping(
                  testPostcode,
                  inputWeight,
                  length,
                  width,
                  height,
                  levy.aramex,
                  'standard'
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试Aramex
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = DFEcalculateShipping(
                  testPostcode,
                  inputWeight,
                  length,
                  width,
                  height
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试DFE
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = SYDFEcalculateShipping(
                  testPostcode,
                  inputWeight,
                  length,
                  width,
                  height
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试SY DFE
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = IMilecalculateShipping(
                  testPostcode,
                  inputWeight,
                  length,
                  width,
                  height
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试iMile
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = HuntercalculateShipping(
                  testPostcode,
                  weight,
                  length,
                  width,
                  height
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试Hunter
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = TNTcalculateShipping(
                  testPostcode,
                  weight,
                  length,
                  width,
                  height
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试TNT
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                const fee = EasyshipcalculateShipping(
                  testPostcode,
                  inputWeight,
                  length,
                  width,
                  height
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试Easyship
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                // FBA uses fixed price >= $13 rate (see FBA_PRODUCT_PRICE constant)
                const fee = FBAcalculateShipping(
                  length,
                  width,
                  height,
                  inputWeight,
                  FBA_PRODUCT_PRICE
                ) * 1.1;
                setTestDeliveryResult(fee);
              }}
            >
              测试FBA
            </button>
          </div>
          <div className="mb-3">
            测试结果：
            {typeof testDeliveryResult === 'object' && testDeliveryResult !== null ? (
              testDeliveryResult.error ? (
                <span className="text-danger">
                  错误: {testDeliveryResult.error}
                  {testDeliveryResult.message && ` - ${testDeliveryResult.message}`}
                </span>
              ) : testDeliveryResult.cost !== undefined ? (
                <span>${testDeliveryResult.cost}</span>
              ) : (
                <span className="text-danger">
                  Error: Object returned but no cost found
                </span>
              )
            ) : (
              <span>${testDeliveryResult}</span>
            )}
          </div>
        </div>
      )}

      {csvUploaded && (
        <div className="mb-4">
          <button onClick={calculateShipping} className="btn btn-primary">
            Calculate
          </button>
        </div>
      )}

      {isLoading && <h2>Loading</h2>}
      {result && result.length > 0 && (
        <div className="mt-4">
          <h2>Result:</h2>
          <p>平均运费：{allShipping}</p>
          <p>免邮区平均运费：{freeZoneShipping}</p>
          <p>FBA运费：{fbaShipping}</p>
          <p>Easyship运费：{easyshipShipping}</p>
          <button onClick={exportToExcel} className="btn btn-success">download excel</button>
        </div>
      )}
    </div>
  );
}

export default CSVShippingPage;